import { render, staticRenderFns } from "./m-card-feature.vue?vue&type=template&id=1db8bc20&scoped=true&v-if=href"
import script from "./m-card-feature.vue?vue&type=script&lang=js"
export * from "./m-card-feature.vue?vue&type=script&lang=js"
import style0 from "./m-card-feature.vue?vue&type=style&index=0&id=1db8bc20&prod&lang=scss"
import style1 from "./m-card-feature.vue?vue&type=style&index=1&id=1db8bc20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db8bc20",
  null
  
)

export default component.exports